import React, { useState, useRef, useEffect } from 'react';
import './InfoTooltip.css';

const InfoTooltip = ({ children, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div className="info-tooltip-container" ref={tooltipRef}>
      <button 
        className="question-link" 
        onClick={toggleTooltip}
        type="button"
      >
        {children}
      </button>
      
      {isVisible && (
        <div className="info-tooltip">
          <div className="tooltip-content">
            <button 
              className="tooltip-close" 
              onClick={() => setIsVisible(false)}
              aria-label="Закрити"
            >
              <i class="bi bi-x"></i>
            </button>
            <div className="tooltip-text">
              {content}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;